import React, { useEffect, useRef, useState } from 'react';
import { IoClose, IoSearch } from 'react-icons/io5';

const DEBOUNCE_MS = 350;

const SearchBar = ({ title, placeholder, onFilterChange, searchKeys, filters }) => {
    const [searchQuery, setSearchQuery] = useState(filters?.search || "");
    const [searchType, setSearchType] = useState(filters?.searchKey || (searchKeys?.length ? searchKeys[0]?.key : ""));
    const debounceRef = useRef(null);
    const firstRun = useRef(true);

    const commitFilters = (query, type) => {
        if (onFilterChange) {
            onFilterChange("search", query);
            onFilterChange("searchKey", type);
        }
    };

    useEffect(() => {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            commitFilters(searchQuery, searchType);
        }, DEBOUNCE_MS);
        return () => clearTimeout(debounceRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery, searchType]);

    useEffect(() => {
        setSearchQuery(filters?.search || "");
        if (filters?.searchKey) setSearchType(filters.searchKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters?.search, filters?.searchKey]);

    const clearSearch = () => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        setSearchQuery("");
        commitFilters("", searchType);
    };

    const currentLabel = searchKeys?.find(k => k.key === searchType)?.value || "Select";

    return (
        <div className='search-bar'>
            <span className="search-bar-icon">
                <IoSearch aria-hidden="true" />
            </span>
            <input
                type="text"
                className="search-bar-input"
                placeholder={placeholder || `Search ${title}...`}
                aria-label={placeholder || `Search ${title}`}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery ? (
                <button
                    type="button"
                    className="search-bar-clear"
                    aria-label="Clear search"
                    onClick={clearSearch}
                >
                    <IoClose />
                </button>
            ) : ""}

            {searchKeys?.length > 1 ? (
                <div className="dropdown">
                    <button className="dropdown-toggle px-3" type="button" data-bs-toggle="dropdown" aria-expanded="false" aria-label={`Search field: ${currentLabel}`}>
                        <span className="small text-muted me-1">By:</span>
                        <span>{currentLabel}</span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end shadow-sm" style={{ position: 'relative', zIndex: 1060, maxHeight: '180px', overflow: 'scroll' }} >
                        {searchKeys?.map((val) => (
                            <li key={val.key}>
                                <button className={`dropdown-item ${searchType === val.key ? 'active' : ''}`} type="button" onClick={() => setSearchType(val.key)} > {val.value}</button>
                            </li>
                        ))}
                    </ul>
                </div>
            ) : ""}
        </div>
    );
};

export default SearchBar;
